export default __webpack_public_path__ + "efb22278917644b0722864cbc8498c2f.png";